export default "__VITE_ASSET__MrDnnEf9__"